import helpers from 'helpers/index'

import constants from 'constants/index'

const {
  LABEL_FUNDAMENTAL_CONCEPTS,
  LABEL_CLEAN_TABLE_AND_SCREEN,
  LABEL_ARTIFICIAL_INTELLIGENCE,
  LABEL_PRIVACY_BY_DESIGN,
} = constants.trailsJourney

const mountUserRow = (user) => [
  [
    LABEL_FUNDAMENTAL_CONCEPTS,
    user?.fundamentalConceptsData?.createdAt
      ? helpers.formatters.dates.ptBrFormatDateTime(
          user?.fundamentalConceptsData?.createdAt,
        )
      : 'Pendente',
  ],
  [
    LABEL_CLEAN_TABLE_AND_SCREEN,
    user?.cleanTableAndScreenData?.createdAt
      ? helpers.formatters.dates.ptBrFormatDateTime(
          user?.cleanTableAndScreenData?.createdAt,
        )
      : 'Pendente',
  ],
  [
    LABEL_ARTIFICIAL_INTELLIGENCE,
    user?.artificialIntelligenceData?.createdAt
      ? helpers.formatters.dates.ptBrFormatDateTime(
          user?.artificialIntelligenceData?.createdAt,
        )
      : 'Pendente',
  ],
  [
    LABEL_PRIVACY_BY_DESIGN,
    user?.privacyByDesignData?.createdAt
      ? helpers.formatters.dates.ptBrFormatDateTime(
          user?.privacyByDesignData?.createdAt,
        )
      : 'Pendente',
  ],
]

export default mountUserRow
